
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sfx/category/[...categorySlug]",
      function () {
        return require("private-next-pages/sfx/category/[...categorySlug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sfx/category/[...categorySlug]"])
      });
    }
  